import spinner from 'components/sharpr/spinner/SpinnerSingleton';

export const KeywordMapValidator = {
	alertError(modal, error) {
		spinner.stopAll();
		modal.alert({ text: error });
	},

	isValidScope({ modal, scope, hubId, accountId }) {
		// check that hub or account are chosen if needed
		let error;
		if (!scope) {
			error = 'Please choose a scope.';
		}
		if (scope == 'hub' && !hubId) {
			error = 'Please choose a hub.';
		} else if (scope == 'account' && !accountId) {
			error = 'Please choose an account.';
		}
		if (error) {
			this.alertError(modal, error);
			return false;
		}
		return true;
	},

	isValid({ modal, scope, map, hubId, accountId }) {
		let error;
		// check that hub or account are chosen if needed
		if (!this.isValidScope({ modal, scope, hubId, accountId })) {
			// error is already alerted
			return;
		} else if (typeof map.is_case_sensitive != 'boolean') {
			error = 'Please choose case sensitivity.';
		} else if (map.from_word.trim() == '') {
			error = 'Vocabulary word is required.';
		} else if (map.to_tag.trim() == '') {
			error = 'AI tag is required.';
		}
		if (error) {
			this.alertError(modal, error);
			return false;
		}
		return true;
	},
};
